<template>
    <el-drawer
        title="编辑题目"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="1200px"
        :before-close="close">
        <div class="panel fx-g1">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="题目内容">
                    <vue-neditor-wrap v-model="form.question" :config="myConfig" :destroy="false"></vue-neditor-wrap>
                    <div v-if="form.type==3" style="margin-top: 5px">
                        <el-button type="primary" @click="increase()">添加占位符</el-button>
                    </div>
                </el-form-item>
                <div v-if="form.type==1 ||form.type==2 || form.type == 5">
                    <el-form-item label="选项A" v-check="{'必填': !form.list[0].content}">
                        <vue-neditor-wrap v-model="form.list[0].content" :config="myConfig"
                                          :destroy="false"></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项B" v-check="{'必填': !form.list[1].content}">
                        <vue-neditor-wrap v-model="form.list[1].content" :config="myConfig"
                                          :destroy="false"></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项C" v-if="form.type != 5" v-check="{'必填': !form.list[2].content}">
                        <vue-neditor-wrap v-model="form.list[2].content" :config="myConfig"
                                          :destroy="false"></vue-neditor-wrap>
                    </el-form-item>
                    <el-form-item label="选项D" v-if="form.type != 5 && form.list[3] != undefined"
                                  v-check="{'必填': !form.list[3].content}">
                        <vue-neditor-wrap v-model="form.list[3].content" :config="myConfig"
                                          :destroy="false"></vue-neditor-wrap>
                    </el-form-item>
                </div>
                <el-form-item label="题目分数">
                    <el-input v-model="form.score"></el-input>
                </el-form-item>
                <!-- <div v-if="form.type==1 ||form.type==2 ||form.type==3 || form.type == 5">
                 <el-form-item label="参考答案">
                    <el-input v-model="form.answer"></el-input>
                </el-form-item>
                </div> -->
                <div v-if="form.type==1||form.type==2||form.type==3||form.type==5">
                    <el-form-item label="参考答案" v-check="{'必填': !form.answer}">
                        <el-select v-model="form.answer" placeholder="参考答案" v-if="form.type==1||form.type==2">
                            <el-option label="A" value="A"></el-option>
                            <el-option label="B" value="B"></el-option>
                            <el-option label="C" value="C"></el-option>
                            <el-option label="D" value="D"></el-option>
                        </el-select>
                        <el-select v-model="form.answer" placeholder="参考答案" v-if="form.type==5 ">
                            <el-option label="A" value="A"></el-option>
                            <el-option label="B" value="B"></el-option>
                        </el-select>
                        <el-input v-model="form.answer" v-if="form.type==3"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="示例代码" v-if="form.type==4" key="code">
                    <el-button type="primary" @click="goEditCode()">去编辑</el-button>
                </el-form-item>
            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="sub()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>

import VueNeditorWrap from 'vue-neditor-wrap'
import {mapMutations} from "vuex";

export default {
    props: [
        "item",
    ],
    components: {
        VueNeditorWrap
    },
    data() {
        return {
            show: false,
            needRefreshParent: false,
            form: {
                ...this.item,
                questionOption: [],

            },

            myConfig: {
                // 如果需要上传功能,找后端小伙伴要服务器接口地址
                serverUrl: '/api/web/upload/ueditor',
                UEDITOR_HOME_URL: '/admin/NEditor/',
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 200,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关闭自动保存
                enableAutoSave: true,
                maximumWords: 2000
            },
            showLoading: false,
            questionOption: [],
            codeFlag: "task_case_" + new Date().getTime(),
        }

    },


    methods: {
        ...mapMutations([
            "addStorageHandler",
            "removeStorageHandler",
        ]),
        goEditCode() {
            if (!this.form.lessonType) {
                this.$showError("请先选择编程语言");
                return;
            }

            let key = this.codeFlag;
            this.addStorageHandler({
                key: key,
                handler: (e) => {
                    if (e.key == key) {
                        console.debug("成功保存示例代码", e);
                        this.form.code = e.newValue;

                        this.removeStorageHandler(key);

                    }
                }
            })
            let codeUrl = this.form.code;
            localStorage.setItem(key, codeUrl);
            this.$goEditCode(this.form.lessonType, "mode=case&id=" + key);
            this.$showWarn("请到新打开的页面中编辑代码，编辑完成后点击上方的【保存代码】按钮", 5000);
        },
        close() {
            this.$emit("close");
        },
        sub() {
            this.$checkForm(this.$refs.form).then(success => {
                if (success) {
                    //校验通过，干什么....
                    this.$ajaxPost("/question/save", {
                        questionBank: this.form, questionOption: this.form.list
                    }, (data) => {
                        this.$emit("submit", data.result);
                        this.showLoading = false;
                        this.needRefreshParent = true;
                        this.$showSuccess("保存成功");
                    })
                    return false;
                } else {
                    this.$showError("请输入内容再保存");
                }
            })

        },
        selectable(row, index) {
            return row.canChoose;
        },
        increase() {
            this.$refs.editor.editor.execCommand('inserthtml', '(__)');
        },

    },
    mounted() {
        this.show = true;
    },
    created() {
    }


}
</script>
